module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"regionsTableCard.title":"Regions this month","regionsTableCard.subtitle":"All regions visible within this tenant"}}')
  delete Component.options._Ctor
}
